var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"AppViewer"}},[_c('DDViewer',_vm._b({},'DDViewer',{ 
      url: _vm.url,
      title: _vm.title,
      isPublic: _vm.isPublic,
      canPrint: _vm.canPrint,
      canDownload: _vm.canDownload,
      isOpenModal: _vm.isOpenModal,
      titleModal: _vm.titleModal,
      contentModal: _vm.contentModal,
      classModal: _vm.classModal,
      baseUrlRedirect: _vm.baseUrlRedirect,
      isSearchTerm: _vm.isSearchTerm,
      ownerRevision: _vm.ownerRevision,
      canPrintSampleWatermark: _vm.canPrintSampleWatermark,
      canPrintWatermarkRevisionHistory: _vm.canPrintWatermarkRevisionHistory,
      canDownloadWatermark: _vm.canDownloadWatermark,
      canPrintWatermark: _vm.canPrintWatermark,
      oldRevision: _vm.oldRevision,
      revisionData: _vm.revisionData
    },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }